import {getState} from '@shopify/theme-cart';
import clsx from 'clsx';
import {useEffect, useState} from 'preact/hooks';
import React, {ReactChild, ElementType} from 'react';
import defaultTheme from './cart.module.pcss';
import {EmptyCart} from './empty-cart';
import {ProductList} from './product-list';

type Props = {
  /**
   * Element node
   * @default 'aside'
   */
  as?: ElementType;
  children?: ReactChild;
  className?: string;
  theme?: {
    root?: string;
    icon?: string;
    error?: string;
    success?: string;
    info?: string;
    text?: string;
  };
};

const initialState: CartItem[] = [];

export const Cart = ({
  as: ComponentProp = 'div',
  className,
  children,
  theme = defaultTheme,
  ...rest
}: Props) => {
  const [items, setItems] = useState(initialState);
  const emptyCart = items.length <= 0;

  useEffect(() => {
    getState().then((data: Cart) => {
      setItems(data.items);
    });
  }, []);

  return (
    <ComponentProp className={clsx(theme.root, className)} {...rest}>
      {emptyCart ? <EmptyCart /> : <ProductList items={items} />}
      {children}
    </ComponentProp>
  );
};
